import axios from 'axios';
import moment from 'moment-timezone';
import store from '../../store/store';
import * as helper from '../../helper/index';

async function getAll(url: string) {
  return await new Promise(async (resolve, reject) => {
    await axios
      .get(`${url}`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        helper.axiosErrorHandling(e);
        reject(e);
      });
  });
}

async function count(url: string) {
  return await new Promise(async (resolve, reject) => {
    await axios
      .get(`${url}`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        helper.axiosErrorHandling(e);
        reject(e);
      });
  });
}

async function get(url: string, id: number) {
  return await new Promise(async (resolve, reject) => {
    await axios
      .get(`${url}/${id}`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
}

async function update(url: string, id: number, data: any) {
  return await new Promise(async (resolve, reject) => {
    await axios
      .put(`${url}/${id}`, data, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
}

async function create(url: string, data: any) {
  return await new Promise(async (resolve, reject) => {
    await axios
      .post(`${url}`, data, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
}

async function publish(url: string, id: number, data: any) {
  return await new Promise(async (resolve, reject) => {
    await axios
      .put(
        `${url}/${id}`,
        {
          ...data,
          published_at: moment.tz('Atlantic/Reykjavik').toISOString(),
        },
        {
          headers: {
            Authorization: `Bearer ${store.getState().auth.jwt}`,
          },
        },
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
}

async function destroy(url: string, id: any) {
  return await new Promise(async (resolve, reject) => {
    await axios
      .delete(`${url}/${id}`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
}

const exportedObject = { get, getAll, create, update, publish, destroy, count };
export default exportedObject;
